import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WxrlRuleDetail, WrxlRulesService } from '../../services/wxrl-rules.service';
import {
  WrxlLogsService,
  WxrlLog,
  WxrlRuleLogsFilter,
} from '../../services/wxrl-logs.service';

@Component({
  selector: 'afoone-wxrl-rule-logs',
  templateUrl: './wxrl-rule-logs.component.html',
  styleUrls: ['./wxrl-rule-logs.component.css'],
})
export class WxrlRuleLogsComponent implements OnInit {
  constructor(
    private _wxrlService: WrxlLogsService,
    private _wxrlRulesService: WrxlRulesService,
    private _router: Router
  ) {}
  public logs: WxrlLog[] = [];
  public wxrlUnauthorized = false;

  public totalOccurrences: number = 0;

  public wordSearch: string | undefined;

  @Input() public rule: WxrlRuleDetail = null;

  ngOnInit(): void {
    this._wxrlRulesService.checkWxrlAccess().then((hasAccess) => {
      if (!hasAccess) this.wxrlUnauthorized = true;
    });
  }

  goToHome(): void {
    this._router.navigate(['/']);
  }

  exportCsv() {
    if (!this.logs || this.logs.length === 0) return;

    const headers = [
      'Fecha / Hora',
      'ID Petición',
      'Fecha Petición',
      'Regla',
      'Registro de trazabilidad',
    ];
    const rows = this.logs.map((log) => [
      this.formatDate(log.timeWhen),
      log.auftrNr,
      this.formatDate(log.einDat, false),
      log.ruleNr,
      log.what,
    ]);

    const csvContent = [headers, ...rows]
      .map((row) =>
        row
          .map((field) => `"${(field ?? '').toString().replace(/"/g, '""')}"`)
          .join(';')
      )
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'logs.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  formatDate(date: Date | string, withTime = true): string {
    if (!date) return '';
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return '';

    const pad = (n: number, len = 2) => String(n).padStart(len, '0');
    const day = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
    if (!withTime) return day;

    return `${day} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${pad(
      d.getMilliseconds(),
      3
    )}`;
  }

  onSearch(filters: WxrlRuleLogsFilter) {
    console.log('onSearch', filters);
    if (this.rule) {
      filters.subjectID = this.rule.ruleNr;
      filters.mode = 'rule';
    }

    this._wxrlService.listLogs(filters).then((logs) => {
      this.logs = logs;
      if (filters.text) {
        this.wordSearch = filters.text;
        this.totalOccurrences = this.countOccurrences();
        console.log(
          `Total occurrences of "${this.wordSearch}": ${this.totalOccurrences}`
        );
      } else {
        this.wordSearch = undefined;
        this.totalOccurrences = 0;
      }
    }).catch((error: any) => {
      const status = error?.status ?? error?.statusCode;
      const msg = error?.error?.message ?? error?.message ?? '';
      if (status === 401 || (typeof msg === 'string' && /not found in database|Username.*not found/i.test(msg))) {
        this.wxrlUnauthorized = true;
      }
    });
  }

  countOccurrences() {
    console.log(`Counting occurrences of "${this.wordSearch}" in logs...`);
    console.log(this.logs);
    if (!this.wordSearch || !this.logs) return 0;

    const regex = new RegExp(this.wordSearch, 'gi');
    return this.logs.reduce((count, log) => {
      const matches = log.what.match(regex);
      return count + (matches ? matches.length : 0);
    }, 0);
  }
}
